module.exports = __webpack_public_path__ + "media/images/logo-footer-e426a10b.svg";